import type { ReactNode } from "react";

import "./ui.css";

interface CardProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  padding?: "default" | "none";
}

export function Card({
  title,
  description,
  actions,
  footer,
  children,
  padding = "default",
}: CardProps) {
  return (
    <section className="card">
      {(title || description || actions) && (
        <header className="card__header">
          <div>
            {title && <h3 className="card__title">{title}</h3>}
            {description && <p className="card__description">{description}</p>}
          </div>
          {actions && <div className="card__actions">{actions}</div>}
        </header>
      )}
      <div className={`card__body${padding === "none" ? " card__body--flush" : ""}`}>{children}</div>
      {footer && <footer className="card__footer">{footer}</footer>}
    </section>
  );
}
